import axios from 'axios';
import BasicService from './basic.service'
import authHeader from "./auth-header";

class AuthService extends BasicService {
    loginOffline(email, password) {
        return axios.post(this.API_URL + 'auth/login/offline', {
                    email: email,
                    password: password,
                }).then(response => {
                    if (response.data.accessToken) {
                        localStorage.setItem('user', JSON.stringify(response.data.user));
                        localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
                    }
    
                    return response.data;
                });
    }
    
    loginToken(dbid, token) {
        return axios.post(this.API_URL + 'auth/login/token', {
                    dbid: dbid,
                    token: token,
                }).then(response => {
                    if (response.data.accessToken) {
                        localStorage.setItem('user', JSON.stringify(response.data.user));
                        localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
                    }
                    
                    return response.data;
                });
    }
    
    getClients() {
        return this.checkError(axios.get(this.API_URL + 'auth/clients'));
    }

    sendToken(dbid) {
        return this.checkError(axios.post(this.API_URL + 'auth/sendToken', { dbid: dbid }));
    }
    
    refreshClientInfo(force) {
        const forceQuery = force ? '?force=5' : '';

        return axios.get(this.API_URL + 'auth/clientInfo' + forceQuery, { headers: authHeader() }).then(
            response => {
                if (response.data.clientDbid) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }
                
                return response.data
            }
        );
    }

    offlineAccountSendId(id) {
        return this.checkError(axios.post(this.API_URL + 'auth/offlineAccount/id/'+encodeURIComponent(id)));
    }

    offlineAccountOnChannel(id) {
        return this.checkError(axios.post(this.API_URL + 'auth/offlineAccount/onChannel/'+encodeURIComponent(id)));
    }

    offlineAccountCreate(id, token, data) {
        return this.checkError(axios.post(this.API_URL + 'auth/offlineAccount/create/'+encodeURIComponent(id)+'/'+encodeURIComponent(token), {...data}));
    }

    offlineAccountResend(id, token) {
        return this.checkError(axios.post(this.API_URL + 'auth/offlineAccount/resend/'+encodeURIComponent(id)+'/'+encodeURIComponent(token)));
    }

    offlineAccountVerify(id, token, emailToken) {
        return this.checkError(axios.post(this.API_URL + 'auth/offlineAccount/verify/'+encodeURIComponent(id)+'/'+encodeURIComponent(token), {emailToken: emailToken}));
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
    }
}

export default new AuthService();